import { cn } from '@theprintbar/shared';
import { ButtonProps, ButtonSize, OutlineButton, SmallArrowIcon } from '@theprintbar/ui';

export function BackToTopButton({ ...props }: ButtonProps) {
	return (
		<OutlineButton
			{...props}
			className={cn('group w-fit flex justify-between h-fit', props.className)}
			onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
			size={ButtonSize.M}
			icon={() => <SmallArrowIcon className="-rotate-45 w-2 h-2 ml-2" />}
		>
			<h5 className="uppercase text-xs">{props.children}</h5>
		</OutlineButton>
	);
}
